export default {
	RetributeAPIUrl: process.env.VUE_APP_RETRIBUTE_API_URL || 'https://api.retribute.me/'
}
